import Vue from 'vue'
import Vuex from 'vuex'
import head from './modules/head'
import search from "./modules/search";
import tags from "./modules/tags";

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        head,
        search,
        tags
    },
})

export default store
